import { render } from "./_vCardTelefono.vue?vue&type=template&id=7c4e978f"
import script from "./_vCardTelefono.vue?vue&type=script&lang=js"
export * from "./_vCardTelefono.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreavadacchino/Desktop/pADV/untitled/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__